import {H6, Small} from "../Typography";
import FlexBox from "../FlexBox";
import {Alert} from "@mui/lab";
import {Button, Stack} from "@mui/material";
import {DeleteRounded, EditRounded, InfoOutlined, InfoRounded} from "@mui/icons-material";
import React from "react";
import {ColumnActionProps} from "../../types/ColumnActionProps";
import {Role} from "../../types/Role";

const RoleListColumnsShape = (props: ColumnActionProps<Role>) => {
    const roleTypeMap: { [key in Role['type']]: string } = {
        user: "Utilisateur",
        driver: "Conducteur",
        admin: "Administrateur"
    }
    return [
        {
            Header: "Nom du rôle",
            accessor: "name",
            minWidth: 100,
        },
        {
            Header: "Type de rôle",
            accessor: "type",
            minWidth: 50,
            Cell: ({value}: any) => (
                <Small
                    style={{textTransform: "capitalize"}}
                    sx={{
                        borderRadius: 10,
                        padding: ".2rem 1rem",
                        color: "background.paper",
                        backgroundColor: "#A798FF",
                    }}>
                    {roleTypeMap[value]}
                </Small>
            )
        }, {
            Header: "Creation",
            accessor: "createdAt",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {new Date(value).toDateString()}
                </Small>
            ),
        }, {
            Header: "Dernière Modification",
            accessor: "updatedAt",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {new Date(value).toDateString()}
                </Small>
            ),
        },
        {
            Header: "Actions",
            accessor: "",
            minWidth: 200,
            Cell: ({row}: any) => (
                <Stack direction={"row"} alignItems={"center"}>
                    <Stack direction={"row"} alignItems={"center"}>
                        <Button startIcon={<EditRounded/>} onClick={() => props.onEditAction(row.original)}>
                            Modifier
                        </Button>
                        <Button variant={"text"} startIcon={<DeleteRounded/>}
                                onClick={() => props.onDeleteAction(row.original)} color={"error"}>
                            Supprimer
                        </Button>
                    </Stack>
                </Stack>
            )
        }
    ]

}

export default RoleListColumnsShape